import {computed, Injectable, signal, Signal, WritableSignal} from '@angular/core';
import {Environment, EnvironmentLight, StorageStrategyType} from '../models/environment.model';
import {of, Subject} from 'rxjs';
import {filter, startWith} from 'rxjs/operators';
import {BsFormOption} from 'bs-components';
import {CurrentUser} from '../models/user.model';

const currentEnvironmentIdKey = 'CurrentEnvironmentId';


@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private readonly _currentEnvironment$: WritableSignal<Environment | undefined> = signal(undefined);

  readonly isMultiEnvironment: WritableSignal<boolean> = signal(false);

  readonly isZBStorageStrategy: Signal<boolean> = computed(() => this.currentEnvironment$()?.storageStrategy === StorageStrategyType.ZB);

  private readonly _environmentChanged$ = new Subject<void>();
  public readonly environmentChanged$ = this._environmentChanged$.asObservable()
    .pipe(
      startWith(() => of()),
      filter(() => !!this._currentEnvironment$())
    );

  public initCurrentEnvironment(currentUser: CurrentUser): void {

    const previousCurrentEnvironmentId = localStorage.getItem(currentEnvironmentIdKey);
    const previousCurrentEnvironment = currentUser.environments
      .find((environment) => environment.id.toString() === previousCurrentEnvironmentId);

    this.updateCurrentEnvironment(previousCurrentEnvironment ?? currentUser.environments[0]);
  }

  public updateCurrentEnvironment(environment: Environment): void {
    if (environment && environment.id != this.currentEnvironment$()?.id) {
      this._currentEnvironment$.set(environment);
      localStorage.setItem(currentEnvironmentIdKey, environment.id.toString());
      this._environmentChanged$.next();
    }
  }

  static toOption(environment: EnvironmentLight): BsFormOption<EnvironmentLight> {
    return {
      id: environment.id?.toString(),
      label: environment.name,
      value: environment
    };
  }

  static toIdOption(environment: EnvironmentLight): BsFormOption<number> {
    return {
      id: environment.id?.toString(),
      label: environment.name,
      value: environment.id
    };
  }

  public get currentEnvironment$(): Signal<Environment | undefined> {
    return this._currentEnvironment$.asReadonly();
  }
}
